import React, { useState, useEffect } from "react";
import data from "./data";
import Article from "./Article";

// keep the theme to user's preference when reload
function getStorageTheme() {
	let theme = "light-theme";
	if (localStorage.getItem("theme")) {
		theme = localStorage.getItem("theme");
	}
	return theme;
}

function App() {
	const [theme, setTheme] = useState(getStorageTheme());

	useEffect(() => {
		document.documentElement.className = theme;
		localStorage.setItem("theme", theme);
	}, [theme]);

	function toggleTheme() {
		setTheme(theme === "light-theme" ? "dark-theme" : "light-theme");
	}

	return (
		<main>
			<nav>
				<div className="nav-center">
					<h1>overreacted</h1>
					<button className="btn" onClick={toggleTheme}>
						toggle
					</button>
				</div>
			</nav>
			<section className="articles">
				{data.map((item) => {
					return <Article key={item.id} {...item} />;
				})}
			</section>
		</main>
	);
}

export default App;
